import Image from "next/image";

import * as styledElements from "./FlashPCBLibLabelStyles";
import { ReactNode } from "react";

const FlashPCBLibLabel = ({
  label,
  labelStyleProps,
}: {
  label: string | ReactNode;
  labelStyleProps?: object;
}) => (
  <styledElements.Container>
    <div>
      <Image src="/icons/icon.png" alt="FlashPCB icon" width="16" height="16" />
    </div>
    <styledElements.Label style={labelStyleProps}>{label}</styledElements.Label>
  </styledElements.Container>
);

export default FlashPCBLibLabel;
